import { Role } from './role.model';
import { RoleInterface } from './role.interface';

export class RoleFactory {

    static empty(): Role {
        return new Role('', '', 0, 'other', false, false, false, false, false, false, false,
            false, false, false, false, false, false, false, false, false, false, false, false, [], [], '');
    }

    static fromObject(raw: RoleInterface | any): Role {
        if (raw.success === false) {
            throw new Error(raw.message);
        }
        return new Role(
            raw.id,
            raw.name,
            raw.order,
            raw.type,
            raw.visibleToMobile,
            raw.invisibleInClass,
            raw.canHaveChildren,
            raw.canHaveMultipleGroups,
            raw.canEditClasses,
            raw.preventActivationOfUsers,
            raw.canEditCategories,
            raw.canSeeTemplates,
            raw.canSelectIfUsersCanReply,
            raw.canSeeFormResults,
            raw.notifyWhenFormClass,
            raw.notifyWhenForm,
            raw.canEditUserFields,
            raw.dontShowCategories,
            raw.outOfOffice,
            raw.canMessageAllGroups,
            raw.disableAbsence,
            raw.enableQuickAnswers,
            raw.disableInFormDropdown,
            raw.roles,
            raw.rolesAll,
            raw.description,
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/roles/shared/role.factory.ts